import { render, staticRenderFns } from "./ZappingButton.vue?vue&type=template&id=d525b56c&scoped=true"
import script from "./ZappingButton.vue?vue&type=script&lang=js"
export * from "./ZappingButton.vue?vue&type=script&lang=js"
import style0 from "./ZappingButton.vue?vue&type=style&index=0&id=d525b56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d525b56c",
  null
  
)

export default component.exports